import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './Sidebar.css';

const navItems = [
  { path: '/home',           icon: '🏠', label: 'Overview' },
  { path: '/dashboard',      icon: '📊', label: 'Dashboard' },
  { path: '/accounts',       icon: '👤', label: 'Accounts' },
  { path: '/add_page',       icon: '➕', label: 'Add Facebook Page' },
  { path: '/import_leads',   icon: '📥', label: 'Import Leads' },
  { path: '/send_leads',     icon: '📤', label: 'Send Leads' },
  { path: '/fetch_leads',    icon: '🔄', label: 'Fetch Leads' },
  { path: '/download_leads', icon: '⬇️', label: 'Download Leads' },
  // { path: '/analysis',       icon: '📉', label: 'Analysis' },
];

const Sidebar = () => {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState(location.pathname);

  useEffect(() => {
    setActiveLink(location.pathname);
  }, [location.pathname]);

  return (
    <div className="tms-sidebar">
      <div className="tms-sidebar-section-label">Menu</div>

      <ul className="tms-sidebar-nav">
        {navItems.map(({ path, icon, label }) => (
          <li key={path}>
            <a
              href={path}
              className={`tms-nav-link ${activeLink === path ? 'active' : ''}`}
              onClick={() => setActiveLink(path)}
            >
              <span className="tms-nav-icon">{icon}</span>
              {label}
            </a>
          </li>
        ))}
      </ul>

      <hr className="tms-sidebar-divider" />

      <div className="tms-sidebar-footer">
        <div className="tms-sidebar-footer-dot" />
        <div className="tms-sidebar-footer-text">
          <strong>System Online</strong>
          All services running
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
